export default __webpack_public_path__ + "static/media/bmw_offer1.0e918af8.jpg";